import { createAsyncThunk } from "@reduxjs/toolkit";

import { apiProxyRequest } from "Api/apiProxyRequest";
import { AsyncThunkOptionType } from "Reducers/types";

import type { ProjectAccess } from "@packages/client";

export const deleteProjectAccessThunk = createAsyncThunk<
  ProjectAccess,
  {
    access: ProjectAccess;
    projectId: string;
    organizationId: string;
    id: string;
  },
  AsyncThunkOptionType
>(
  "app/project/access/delete",
  async ({ access, projectId }, { rejectWithValue }) => {
    if (!access) return rejectWithValue("");
    await apiProxyRequest(
      `/projects/${projectId}/access/${access.id}`,
      "DELETE"
    );
    return access;
  }
);
